import { useDrawer } from '~/shared/ui/Drawer'
import { InfoSmallOutlinedIcon } from '~/shared/ui/icons'
import { MoreDrawer } from './MoreDrawer'
import { InfoIconWrapper, TitleWrapper, Wrapper } from './styled'

export function More() {
  const [isDrawerShow, openDrawer, closeDrawer] = useDrawer()
  return (
    <>
      <Wrapper onClick={openDrawer}>
        <TitleWrapper>
          <InfoIconWrapper>
            <InfoSmallOutlinedIcon />
          </InfoIconWrapper>
        </TitleWrapper>
      </Wrapper>

      <MoreDrawer isShow={isDrawerShow} onClose={closeDrawer} />
    </>
  )
}
